import React, { useRef } from 'react'
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Navigation } from "swiper/modules"
import Organizator from "src/components/Organizator/Organizator"
import './Carousel.scss'
import { AppCompaniesChoices } from "src/types"
import { shuffleArray } from "src/helpers"
import { useGetCarouselConfig } from "src/hooks"

const Carousel = () => {
    const swiperRef = useRef<any>(null)
    const { slidesPerView } = useGetCarouselConfig()

    const companiesList = shuffleArray(Object.keys(AppCompaniesChoices))

    const handlePrevSlide = () => {
        swiperRef.current?.slidePrev()
    }
    const handleNextSlide = () => {
        swiperRef.current?.slideNext()
    }

    return (
        <div className={"carousel"}>
            <img
                src="/slider/navigation-left.svg"
                alt=""
                className={"carousel__prev"}
                onClick={handlePrevSlide}
            />
            <Swiper
                slidesPerView={slidesPerView}
                modules={[Navigation, Autoplay]}
                onBeforeInit={(swiper: any) => {
                    swiperRef.current = swiper
                }}
                className={"carousel__swiper"}
                freeMode={true}
                loop={true}
                spaceBetween={16}
                centeredSlides={true}
            >
                {companiesList.map((key, index) => {
                    return (
                        <SwiperSlide key={index}>
                            <Organizator company={key as AppCompaniesChoices}/>
                        </SwiperSlide>
                    )
                })}
            </Swiper>
            <img
                src="/slider/navigation-right.svg"
                alt=""
                className={"carousel__next"}
                onClick={handleNextSlide}
            />
        </div>
    )
}

export default Carousel